/**
 * @module WinePreviewService
 * @description Service for fetching package preview data
 * @param productVariantIds - array of product variant IDs (list of long integers)
 * @returns Promise that resolves to the response
 */
export const fetchWinesForPreview = async (productVariantIds: number[]) => {
  try {
    const response = await fetch(`/Widget/WineProductVariantForCarousel`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(productVariantIds),
    });

    return await response.json();
  } catch (error) {
    throw new Error(error);
  }
};
